<template>
  <Modal type="modal-sm">
    <div class="text-center">
      <IconCheck height="50" class="active mb-3" />
      <p>Thank you for subscribing to {{plan|upperFirst}} plan.</p>
      <button class="btn btn-primary" @click="next">Continue</button>
    </div>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import filters from '@/mixins/filters'
import Modal from '@/components/Modal'

export default {
  mixins: [ filters ],
  components: {
    Modal
  },
  computed: mapState([ 'plan' ]),
  methods: {
    next: function () {
      this.$emit('next')
    }
  }
}
</script>
